import { TLanguage } from 'config/tenancy';

const isDevMode = process.env.NODE_ENV === 'development';

const DEVELOPMENT_COUNTRY_CODE = '1';
const DEVELOPMENT_CONTACT = '555 6005912';

export const CONTACTS: Record<TLanguage, string> = {
  pt: isDevMode ? DEVELOPMENT_CONTACT : '0800 942 2345',
  es: isDevMode ? DEVELOPMENT_CONTACT : '217289303',
  'es-CR': isDevMode ? DEVELOPMENT_CONTACT : '70999808',
};

export const COUNTRY_CODES: Record<TLanguage, string> = {
  pt: isDevMode ? DEVELOPMENT_COUNTRY_CODE : '55',
  es: isDevMode ? DEVELOPMENT_COUNTRY_CODE : '595',
  'es-CR': isDevMode ? DEVELOPMENT_COUNTRY_CODE : '506',
};

export const CONTACT_DEFAULT_MESSAGES: Record<TLanguage, string[]> = {
  pt: ['Olá Lisa!', 'Olá! Quero saber mais sobre depilação a laser'],
  es: ['¡Hola Lisa!', '¡Hola! Quiero saber más sobre depilación láser'],
  'es-CR': ['¡Hola Lisa!', '¡Hola! Quiero saber más sobre depilación láser'],
};

export const DEFAULT_CUSTOMER_SERVICE_LINK =
  'https://bitly.vialaser.com.br/atendimento-cliente';
